import { Box, Divider } from '@mui/material';
import RetrosToolbar from './RetrosToolbar';
import { useProjectRetroContext } from '../../context';
import { ArticleFieldsType, ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import SummarizeLearnings from './SummarizeLearnings';
import LessonTypeSummaryBar from './LessonTypeSummaryBar';
import { useArticleInputFields } from '@buildwise/libs/posts';
import { Dictionary, keyBy } from 'lodash';
import { useMemo } from 'react';
import { ConfigEntryType } from 'config/config';

function RetrosHeader({ filteredLessons }: { filteredLessons: ArticleType[] }) {
  const {
    state: { isFullScreen },
  } = useProjectRetroContext();
  const { articleFieldsToRender } = useArticleInputFields({
    articleFieldsType: ArticleFieldsType.LESSON,
    isEditing: false,
  });
  const enabledArticleFieldsToRender: Dictionary<ConfigEntryType | undefined> = useMemo(
    () => keyBy(articleFieldsToRender, 'entryCode'),
    [articleFieldsToRender],
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={isFullScreen ? 'flex-start' : 'space-between'}
      gap={1}
    >
      <Box display="flex" alignItems="center" gap={1}>
        {enabledArticleFieldsToRender['lessonTypes']?.isActive && <LessonTypeSummaryBar />}
        {filteredLessons?.length > 0 && <SummarizeLearnings lessons={filteredLessons} />}
      </Box>
      {isFullScreen && <Divider orientation="vertical" sx={{ height: 30 }} />}
      <Box>
        <RetrosToolbar lessons={filteredLessons} />
      </Box>
    </Box>
  );
}

export default RetrosHeader;
